import client from './client';

const Guarantors = {
  getGuarantors(anketId) {
    return client.get(`/ankets/${anketId}/guarantors`);
  },
  getGuarantor(anketId, guarantorId) {
    return client.get(`/ankets/${anketId}/guarantors/${guarantorId}`);
  },
};

export default Guarantors;
